import { Box } from "@chakra-ui/react";
import ArrivalRatesPerServiceTable from "../../tables/daily/ArrivalRatesPerServiceTable";
import EnterpriseReportSummary from "../../../reports/EnterpriseReportSummary";
import { buildArrivalInsights } from "../../../../store/reportEnterpriseInsights";


const BranchArrivalRatesPerService = ({ data }) => {
  return (
    <Box>
      {data.map(({ branchName, servicesData }, branchIndex) => {
        const title = `${branchIndex + 1}. ${branchName}`;
        const insights = buildArrivalInsights(servicesData, { scopeLabel: "Service" });
        
        return (
          <>
            <h2>{title}</h2>
            <EnterpriseReportSummary
              title="Daily Service Arrival Demand Summary"
              kpis={insights.kpis}
              tables={insights.tables}
              notes={insights.notes}
            />
            {servicesData.map((data, index) => {
              return (
                <ArrivalRatesPerServiceTable
                  index={index}
                  data={data}
                  branchIndex={branchIndex}
                  
                  branchName={branchName}
                />
              );
            })}
          </>
        );
      })}
    </Box>
  );
};

export default BranchArrivalRatesPerService;
